var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDevicesOutlinedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3523_168112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6101 3.59121H1.95666C1.00813 3.59121 0.236719 4.36262 0.236719 5.31115V22.4135C0.236719 23.362 1.00813 24.1334 1.95666 24.1334H10.8392L10.4675 27.1069H9.97334C9.61383 27.1069 9.32228 27.3984 9.32228 27.758C9.32228 28.1175 9.61374 28.409 9.97334 28.409H12.6456C13.0051 28.409 13.2967 28.1176 13.2967 27.758C13.2967 27.3984 13.0052 27.1069 12.6456 27.1069H11.7798L12.1514 24.1334H12.6456C13.0051 24.1334 13.2967 23.8419 13.2967 23.4823C13.2967 23.1228 13.0052 22.8313 12.6456 22.8313H1.95666C1.72637 22.8313 1.53878 22.6437 1.53878 22.4134V20.9266H12.6456C13.0051 20.9266 13.2967 20.6352 13.2967 20.2756C13.2967 19.916 13.0052 19.6245 12.6456 19.6245H1.53878V5.31115C1.53878 5.08087 1.72637 4.89327 1.95666 4.89327H27.6101C27.8404 4.89327 28.028 5.08087 28.028 5.31115V16.0001C28.028 16.3596 28.3194 16.6511 28.679 16.6511C29.0385 16.6511 29.3301 16.3597 29.3301 16.0001V5.31115C29.33 4.36262 28.5586 3.59121 27.6101 3.59121Z",
    fill: "#E1E0E4",
    stroke: "#E1E0E4",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7552 26.6886V26.6959C23.7512 26.9228 23.5652 27.1065 23.3373 27.1065H15.8551C15.6248 27.1065 15.4372 26.9189 15.4372 26.6886V26.2707H23.7552V26.6886ZM23.7552 16.6507V24.9687H15.4372V16.6507H23.7552ZM23.3373 13.2108H15.8551C14.9066 13.2108 14.1352 13.9822 14.1352 14.9308V26.6886C14.1352 27.6371 14.9066 28.4085 15.8551 28.4085H23.3373C24.2859 28.4085 25.0573 27.6371 25.0573 26.6886V14.9308C25.0573 13.9822 24.2859 13.2108 23.3373 13.2108ZM23.7552 15.3486H15.4372V14.9307C15.4372 14.7004 15.6248 14.5128 15.8551 14.5128H23.3373C23.5676 14.5128 23.7552 14.7004 23.7552 14.9307V15.3486Z",
    fill: "#E1E0E4",
    stroke: "#E1E0E4",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2374 26.6889V26.6962C31.2335 26.9231 31.0474 27.1068 30.8196 27.1068H27.6129C27.3826 27.1068 27.195 26.9192 27.195 26.6889V26.271H31.2374V26.6889ZM30.8196 17.4867H27.6129C26.6644 17.4867 25.893 18.2581 25.893 19.2067V26.6889C25.893 27.6374 26.6644 28.4088 27.6129 28.4088H30.8196C31.7681 28.4088 32.5395 27.6374 32.5395 26.6889V19.2067C32.5395 18.2581 31.7681 17.4867 30.8196 17.4867ZM31.2375 24.969H27.1951V20.9266H31.2375V24.969ZM31.2375 19.6245H27.1951V19.2067C27.1951 18.9764 27.3827 18.7888 27.613 18.7888H30.8197C31.0499 18.7888 31.2375 18.9764 31.2375 19.2066C31.2375 19.2066 31.2375 19.2067 31.2375 19.2067L31.2375 19.6245Z",
    fill: "#E1E0E4",
    stroke: "#E1E0E4",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3523_168112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.386719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDevicesOutlinedWhite);
export default __webpack_public_path__ + "static/media/icon_devices_outlined_white.cfc2c5682a9e6c8b51abebd66e59d6b9.svg";
export { ForwardRef as ReactComponent };